function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "icons8-javascript-logo",
  d: "M82.974,2.625A1.926,1.926,0,0,0,81.554,2H6.388A1.923,1.923,0,0,0,4.472,4.1l6.772,75.849a1.927,1.927,0,0,0,1.389,1.679l30.8,8.8a1.937,1.937,0,0,0,1.054,0l30.827-8.8A1.927,1.927,0,0,0,76.7,79.944L83.47,4.1A1.928,1.928,0,0,0,82.974,2.625ZM18.962,53.95l13.467,3.736V19.314h7.7V69.333L18.962,63.463ZM69.084,40.476,67.056,64.042l-19.238,5.29V60.481L60.8,56.913l.481-7.214-13.467,2.32v-32.7H70.9l-.664,7.7H55.514V42.4Z",
  transform: "translate(-4.464 -2)"
});

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.014,
    height: 88.494,
    viewBox: "0 0 79.014 88.494",
    transform: "translate(0 5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/Javascript.d41c0ff3.svg";
export { ForwardRef as ReactComponent };